export default "<h1 class=\"text-light text-center mb-5\">{{ nomeTitulo }}</h1>\r\n"